module.exports = __webpack_public_path__ + "static/media/abstrato-2.0b2b62a6.jpg";